var map = {
	"./bn.json": [
		3389,
		389
	],
	"./en.json": [
		1937,
		318
	],
	"./es.json": [
		5029,
		29
	],
	"./id.json": [
		8312,
		312
	],
	"./ja.json": [
		5708,
		708
	],
	"./km.json": [
		7625,
		625
	],
	"./ko.json": [
		1503
	],
	"./mn.json": [
		9222,
		222
	],
	"./my.json": [
		5979,
		979
	],
	"./ne.json": [
		7108,
		108
	],
	"./ru.json": [
		6344,
		344
	],
	"./si.json": [
		1253,
		253
	],
	"./th.json": [
		2973,
		973
	],
	"./tl.json": [
		9113,
		113
	],
	"./ur.json": [
		5210,
		210
	],
	"./uz.json": [
		3074,
		74
	],
	"./vi.json": [
		8968,
		968
	],
	"./zh.json": [
		8743,
		743
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2960;
module.exports = webpackAsyncContext;